import styles from "./style.module.scss";
import { motion } from "framer-motion";
import { ReactNode } from "react";

export default function PartneringWithSeveralBrands({
    list,
    mainTitle,
    benefitListClassName,
    benefitItemClassName,
}: {
    list: { title: string; p: string; icon: ReactNode }[];
    mainTitle: string;
    benefitListClassName?: string;
    benefitItemClassName?: string;
}) {
    return (
        <motion.section
            transition={{ duration: 1.5 }}
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`lg:mt-32 mt-16 `}
        >
            <h2 className="font-bold text-[#37367D] 3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto">
                {mainTitle}
            </h2>

            <ul
                className={`flex  flex-wrap  lg:mt-12 mt-8 lg:gap-10 gap-5 justify-center  ${
                    benefitListClassName ?? ""
                }`}
            >
                {list.map((el, index) => (
                    <motion.li
                        transition={{ duration: 1.5 }}
                        initial={{ opacity: 0, y: 150 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        key={index}
                        className={`${styles["benefitItemStyle"]} ${
                            benefitItemClassName ?? ""
                        } `}
                    >
                        <span>{el.icon}</span>
                        <h2
                            className={
                                "text-[#37367D]  text-lg lg:text-2xl 3xl:text-4xl lg:leading-10 mt-7 font-bold"
                            }
                        >
                            {el.title}
                        </h2>
                        <p
                            className={
                                "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-3 font-light"
                            }
                        >
                            {el.p}
                        </p>
                    </motion.li>
                ))}
            </ul>
        </motion.section>
    );
}
